import React, {useEffect } from 'react';
import { lookerStudioReportSessionGraphsLab } from './resources';

function SessionGraph(sessionId) {
    useEffect(() => {
        const intervalId = setInterval(() => {
            // Update sessionId variable here with new data
        }, 5000); // Refresh every 5 seconds

        return () => clearInterval(intervalId);
    }, []); // Only run once when component is mounted

    return (
        <div>
            <iframe
                id="session-graph"
                width="1100"
                height="700"
                // style={{
                // //     position: 'fixed',
                //     right: '40%',
                // //     transform: 'translateX(-50%)',
                // //     bottom: 0,
                // //     margin:"50px",
                // }}
                src={lookerStudioReportSessionGraphsLab(sessionId.sessionId)}
                allowFullScreen
                sandbox="allow-same-origin allow-scripts"
            />
        </div>
    );
}

export default SessionGraph
